// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=rtl] .contentinfo[data-v-d37071aa],[dir=rtl] .rowinfo[data-v-d37071aa]{text-align:right}[dir=ltr] .contentinfo[data-v-d37071aa],[dir=ltr] .rowinfo[data-v-d37071aa]{text-align:left}.sticky-preview[data-v-d37071aa]{position:sticky;top:0!important;-ms-flex-item-align:start;align-self:flex-start;height:-webkit-max-content;height:-moz-max-content;height:max-content;z-index:10}", ""]);
// Exports
module.exports = exports;
